
import CodeHelpers from './CodeHelpers.js'
import ParseExpression from './ParseExpression.js'

function ParseSentenceAssign (parser) {
    this.parser = parser
    this.scanner = parser.scanner
    this.pcode = parser.pcode
    this.stable = parser.stable
    this.SC = parser.config
}

ParseSentenceAssign.prototype = {
    parse () {
        let ident
        let resultType
        let token
        let codeHelpers = new CodeHelpers(this.parser)
        let parseExpression = new ParseExpression(this.parser)

        ident = this.parser.expect(this.SC.IDENT)

        if (ident !== false) {
            if (!this.stable.hasStorage(ident.lexema)) {
                if (this.scanner.nextIs(this.SC.OPEN_PAR)) {
                    this.parser.error(ident, 'El procedimiento ' + ident.lexema + ' no está definido.')
                } else {
                    this.parser.error(ident, 'La variable ' + ident.lexema + ' no está definida.')
                }
            } else if (this.stable.getStorage(ident.lexema).getType().isArray()) {
                token = this.parser.expect(this.SC.INDEX_SEL_OPEN)
                if (token === false) {
                    this.parser.error(ident, 'La variable ' + ident.lexema + ' es un arreglo, se esperaba apertura de corchetes.')
                }

                token = this.scanner.next()

                resultType = parseExpression.parse()

                if (!resultType.isInt()) {
                    this.parser.error(token, 'La expresión para acceder al arreglo debe ser de tipo entera.')
                }

                this.parser.expect(this.SC.INDEX_SEL_CLOSE)
            }
        }

        this.parser.expect(this.SC.ASSIGN)

        resultType = parseExpression.parse()

        if (this.stable.hasStorage(ident.lexema)) {
            if (!codeHelpers.semanticsAssignCast(this.stable.getStorage(ident.lexema).getType(), resultType)) {
                this.parser.error(ident, 'El tipo de la variable no coincide con el tipo de la expresión.')
            } else if (this.parser.compile) {
                codeHelpers.codeStoreVar(ident.lexema, ident)
            }
        }

        this.parser.expect(this.SC.SEMICOLON)
    }
}

export default ParseSentenceAssign



// WEBPACK FOOTER //
// ./src/Core/Parser/Components/ParseSentenceAssign.js